export enum ErrorKeys {
  SENTRY_NOT_CONFIGURED = 'sentry_not_configured',
}
